import { MEMBER_ROLE, getRoleLabel } from 'constants/users'
export const NAME_FIELD = 'first_name'
export const LAST_NAME_FIELD = 'last_name'
export const ROLE_FIELD = 'role'
export const ADDRESS_FIELD = 'email'
export const PASSWORD_FIELD = 'password'
export const INVITE_FIELD = 'invite'
export const DEPARTMENT_FIELD = 'department'

export const defaultValues = {
  [NAME_FIELD]: '',
  [LAST_NAME_FIELD]: '',
  [ROLE_FIELD]: {
    value: MEMBER_ROLE,
    label: getRoleLabel(MEMBER_ROLE),
  },
  [ADDRESS_FIELD]: '',
  [PASSWORD_FIELD]: '',
  [INVITE_FIELD]: true,
  [DEPARTMENT_FIELD]: [],
}
